
import { Component, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'src/app/core/services/toast.service';
import { EStampService } from 'src/app/core/services/e-stamp.service';
import { AuthfakeauthenticationService } from 'src/app/core/services/authfake.service';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/core/services/account.service';
import { ApiValidationError } from 'src/app/shared/models/api-validation.model';
import { normalizeApiValidationError } from 'src/app/shared/utils/api-validation.util';

@Component({
    selector: 'app-create-customer-order',
    templateUrl: './create-customer-order.component.html',
    styleUrl: './create-customer-order.component.scss',
    standalone: false
})
export class CreateCustomerOrderComponent {

  activeTab: 'onDemand' | 'bulkCreate' | 'bulkUpload' = 'bulkUpload';
  @ViewChild('fileInput') fileInput: any;

  selectedFile!: File;
  loading: boolean = false;
  loadConfig: boolean = false;
  apiValidationError: ApiValidationError | null = null;
  orderForm!: FormGroup;
  userDetail: any = {};
  states: any[] = [];
  fileSizeError: string | null = null;
  readonly maxFileSizeBytes: number = 10 * 1024 * 1024; // 10MB

  constructor
    (
      private fb: FormBuilder,
      private eStampService: EStampService,
      private router: Router,
      private authService: AuthfakeauthenticationService,
      private toastService: ToastService,
      private accountService: AccountService,
    ) { }

  ngOnInit() {
    this.createOrder();
    this.authService.currentUser.subscribe((res: any) => {
      this.userDetail = res?.user;
      const existingFirstPartyName = this.orderForm.get('firstParty')?.value;
      if (!existingFirstPartyName && this.userDetail?.name?.trim()) {
        this.orderForm.patchValue({
          firstParty: this.userDetail.name.trim()
        });
      }
      this.loadCustomerConfig(this.userDetail?.email);
    })

    this.getStates();
  }

  // ===== SEND STAMP DOCUMENT TAB =====
  createOrder() {
    this.orderForm = this.fb.group({
      stateId: ['', Validators.required],
      denomination: ['', Validators.required],
      purpose: ['', Validators.required],
      firstParty: ['', Validators.required],
      secondParty: ['', Validators.required],
      appendStampPosition: ['PRE', Validators.required]
    });

  }

  private loadCustomerConfig(
    clientEmail: string | null | undefined
  ): void {
    this.loadConfig = true;
    const normalizedEmail: any = clientEmail?.trim().toLowerCase();

    this.accountService
      .getEstampClientConfig(normalizedEmail)
      .subscribe({
        next: (response: any) => {
          this.loadConfig = false;
          const apiFirstPartyName =
            response?.data?.stamp?.firstParty;

          if (apiFirstPartyName?.trim()) {
            this.orderForm.patchValue({
              firstParty: apiFirstPartyName.trim()
            });
          }
        },

        error: () => {
          this.loadConfig = false;
        }
      });
  }

  getStates() {
    this.eStampService.getStates().subscribe((res: any) => {
      this.states = res?.data;
    });
  }

  onSubmit() {
    if (this.loading) {
      return;
    }

    this.apiValidationError = null;

    if (!this.orderForm.valid) {
      this.toastService.showToaster(
        "Warning",
        "Please provide all required data.",
        "info"
      );

      this.loading = false;
      return;
    }

    if (!this.selectedFile) {
      this.toastService.showToaster(
        "Warning",
        "Please select file.",
        "info"
      );

      this.loading = false;
      return;
    }

    const payload = {
      ...this.orderForm.value,
      file: this.selectedFile
    };

    this.loading = true;

    this.eStampService.createOrder(payload, true).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.apiValidationError = null;

        this.router.navigate([
          '/customer/estamp/customer-order-list'
        ]);

        this.toastService.showToaster(
          "Success",
          res?.message || "Order created successfully.",
          "success"
        );
      },

      error: (error: any) => {
        this.loading = false;

        // Create-order API error in red inline box
        this.apiValidationError =
          normalizeApiValidationError(error);
      }
    });
  }
  allowInput(event: KeyboardEvent, type: 'number' | 'text') {
    const char = String.fromCharCode(event.keyCode);

    if (type === 'number') {
      if (!/^[0-9]$/.test(char)) {
        event.preventDefault();
      }
    }

    if (type === 'text') {
      if (!/^[a-zA-Z ]$/.test(char)) {
        event.preventDefault();
      }
    }
  }

  onFileSelect(event: any) {
    const file = event.target.files[0];
    this.fileSizeError = null;
    if (!file) {
      return;
    }

    const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');

    if (!isPdf) {
      this.selectedFile = undefined as any;
      event.target.value = '';
      this.toastService.showToaster(
        "Invalid File",
        "Please upload the required document in PDF format only.",
        "info"
      );
      return;
    }

    if (file.size > this.maxFileSizeBytes) {
      this.selectedFile = undefined as any;
      event.target.value = '';
      this.fileSizeError = `File size (${(file.size / (1024 * 1024)).toFixed(2)} MB) exceeds the maximum limit of 10MB. Please upload a smaller file.`;
      this.toastService.showToaster(
        "Invalid File",
        this.fileSizeError,
        "info"
      );
      return;
    }

    this.selectedFile = file;
  }

  clearApiValidationMessage(): void {
    this.apiValidationError = null;
  }

}



